export default "__VITE_ASSET__CCTpoGxg__";